var map = {
	"./animals_bear.png": "4ab7",
	"./animals_cat1.png": "5772",
	"./animals_cat2.png": "7de1",
	"./animals_cat3.png": "ab62",
	"./animals_chicken.png": "2972",
	"./animals_cow.png": "d4b8",
	"./animals_deer.png": "d49d",
	"./animals_duck.png": "915d",
	"./animals_elephant.png": "cddc",
	"./animals_fox.png": "bc2a",
	"./animals_frog.png": "3b7f",
	"./animals_giraffe.png": "ac8a",
	"./animals_goat.png": "34df",
	"./animals_lion.png": "70d7",
	"./animals_monkey.png": "03f3",
	"./animals_mouse.png": "bc7c",
	"./animals_owl.png": "5490",
	"./animals_panda.png": "34bf",
	"./animals_penguin.png": "07d5",
	"./animals_pig.png": "c484",
	"./animals_poodle.png": "a3cb",
	"./animals_rabbit.png": "01fc",
	"./animals_redpanda.png": "c9a8",
	"./animals_sheep.png": "75e0",
	"./animals_shibainu.png": "7ab0",
	"./animals_tiger.png": "225e",
	"./animals_wolf.png": "eeb3",
	"./awards/awards_chip1.png": "1a55",
	"./awards/awards_chip2.png": "7621",
	"./awards/awards_chip3.png": "4e1a",
	"./awards/awards_chip4.png": "51c5",
	"./awards/awards_decoration1.png": "6916",
	"./awards/awards_decoration2.png": "a0c1",
	"./awards/awards_decoration3.png": "5c40",
	"./awards/awards_firstplace.png": "2841",
	"./awards/awards_medal.png": "6f92",
	"./awards/awards_money1.png": "605c",
	"./awards/awards_money2.png": "e941",
	"./awards/awards_moneybag.png": "6132",
	"./awards/awards_secondplace.png": "b9e6",
	"./awards/awards_thirdplace.png": "d6d7",
	"./awards/awards_trophies.png": "e153",
	"./awards/awards_trophy1.png": "6ac6",
	"./awards/awards_trophy2.png": "e26c",
	"./awards/awards_trophy3.png": "2727",
	"./chess/chess_checkersblue.png": "c815",
	"./chess/chess_checkersgreen.png": "9e20",
	"./chess/chess_checkerspurple.png": "79ca",
	"./chess/chess_checkersred.png": "5faa",
	"./chess/chess_checkersyellow.png": "0f44",
	"./chess/chess_chessblack1.png": "a222",
	"./chess/chess_chessblack2.png": "08ec",
	"./chess/chess_chessblack3.png": "5315",
	"./chess/chess_chessblack4.png": "6870",
	"./chess/chess_chessblack5.png": "1dbc",
	"./chess/chess_chessblack6.png": "6d98",
	"./chess/chess_chesswhite1.png": "c330",
	"./chess/chess_chesswhite2.png": "52d9",
	"./chess/chess_chesswhite3.png": "a25e",
	"./chess/chess_chesswhite4.png": "5cfc",
	"./chess/chess_chesswhite5.png": "951f",
	"./chess/chess_chesswhite6.png": "7258",
	"./chess/chess_chinesechessblack1.png": "e3ae",
	"./chess/chess_chinesechessblack2.png": "f820",
	"./chess/chess_chinesechessblack3.png": "cf05",
	"./chess/chess_chinesechessblack4.png": "f00b",
	"./chess/chess_chinesechessblack5.png": "c1a6",
	"./chess/chess_chinesechessblack6.png": "805b",
	"./chess/chess_chinesechessblack7.png": "78e9",
	"./chess/chess_chinesechessred1.png": "197c",
	"./chess/chess_chinesechessred2.png": "6def",
	"./chess/chess_chinesechessred3.png": "b31f",
	"./chess/chess_chinesechessred4.png": "9db8",
	"./chess/chess_chinesechessred5.png": "5445",
	"./chess/chess_chinesechessred6.png": "1c31",
	"./chess/chess_chinesechessred7.png": "3510",
	"./chess/chess_goblack.png": "2fd6",
	"./chess/chess_gowhite.png": "564a",
	"./chess/chess_japanchess01.png": "2fdb",
	"./chess/chess_japanchess02.png": "867d",
	"./chess/chess_japanchess03.png": "92c9",
	"./chess/chess_japanchess04.png": "4838",
	"./chess/chess_japanchess05.png": "d862",
	"./chess/chess_japanchess06.png": "4663",
	"./chess/chess_japanchess07.png": "6087",
	"./chess/chess_japanchess08.png": "5f7a",
	"./chess/chess_japanchess09.png": "eafb",
	"./chess/chess_japanchess10.png": "2bdb",
	"./chess/chess_japanchess11.png": "d8ec",
	"./chess/chess_japanchess12.png": "8a84",
	"./chess/chess_japanchess13.png": "b11c0",
	"./chess/chess_japanchess14.png": "91b3",
	"./chess/chess_japanchess15.png": "45462",
	"./drink/drink_bubbletea.png": "1322",
	"./drink/drink_coffee.png": "b791",
	"./drink/drink_cola.png": "982a",
	"./drink/drink_fanta.png": "df64",
	"./drink/drink_latte.png": "3293",
	"./drink/drink_pepsi.png": "9b67",
	"./drink/drink_sprite.png": "b46f",
	"./drink/drink_tea.png": "5c38",
	"./face/mood_angry.png": "48c7f",
	"./face/mood_cold.png": "2a71",
	"./face/mood_cry.png": "6201",
	"./face/mood_devil.png": "a9d3",
	"./face/mood_die.png": "bf8a",
	"./face/mood_doubt.png": "b413",
	"./face/mood_happy.png": "92ac",
	"./face/mood_hot.png": "bea9",
	"./face/mood_hurt.png": "f054",
	"./face/mood_lauth.png": "44ae",
	"./face/mood_love.png": "5fcd",
	"./face/mood_rolleyes.png": "2041",
	"./face/mood_sad.png": "657c",
	"./face/mood_shock.png": "a652",
	"./face/mood_sick.png": "591c",
	"./face/mood_sleep.png": "6b1b",
	"./face/mood_smile.png": "7757",
	"./festival/festival_chinesenewyear1.png": "9341",
	"./festival/festival_chinesenewyear2.png": "4791",
	"./festival/festival_christmas.png": "743f",
	"./festival/festival_dragonboatfestival.png": "ef1a",
	"./festival/festival_easter.png": "3680",
	"./festival/festival_gift.png": "d969",
	"./festival/festival_halloween.png": "570d",
	"./festival/festival_luckycat.png": "ff40",
	"./fish/fish_bigclam.png": "97f1",
	"./fish/fish_clownfish.png": "91d6",
	"./fish/fish_crab.png": "7938",
	"./fish/fish_eel.png": "a42f",
	"./fish/fish_goldfish.png": "93e2",
	"./fish/fish_octopus.png": "8ce6",
	"./fish/fish_pufferfish.png": "9a8e",
	"./fish/fish_shrimp.png": "19b7",
	"./fish/fish_snapper.png": "1744",
	"./fish/fish_squid.png": "2d7f",
	"./fish/fish_starfish.png": "8306",
	"./fish/fish_tropicalfish.png": "e850",
	"./fish/fish_yellowfish.png": "1987",
	"./food/food_cake.png": "8f4a",
	"./food/food_dounut.png": "814b",
	"./food/food_hamburger.png": "6cdf",
	"./food/food_icecream.png": "c9d2",
	"./food/food_pieceofcake.png": "f200",
	"./food/food_pizza.png": "5d5c",
	"./food/food_popcorn.png": "607b",
	"./food/food_roastchicken.png": "46ac",
	"./food/food_steak.png": "3e49",
	"./fruit/fruit_apple.png": "9a72",
	"./fruit/fruit_banana.png": "6204",
	"./fruit/fruit_cantaloupe.png": "c9f6",
	"./fruit/fruit_cherry.png": "ab34",
	"./fruit/fruit_grape.png": "f625",
	"./fruit/fruit_grapefruit.png": "83a2",
	"./fruit/fruit_kiwi.png": "c649",
	"./fruit/fruit_lemon.png": "37a1",
	"./fruit/fruit_lyme.png": "d36f",
	"./fruit/fruit_mulberry.png": "2ed8",
	"./fruit/fruit_orange.png": "56e4",
	"./fruit/fruit_pinapple.png": "434a",
	"./fruit/fruit_snakeberry.png": "875a",
	"./fruit/fruit_strawberry.png": "fac8",
	"./fruit/fruit_watermelon.png": "0e49f",
	"./gesture_five.png": "c2ea",
	"./gesture_good.png": "d444",
	"./gesture_ok.png": "8ea12",
	"./gesture_one.png": "9e85",
	"./gesture_yeah.png": "535f",
	"./gesture_zero.png": "8cd2",
	"./manda/manda_001.png": "5edb",
	"./manda/manda_002.png": "e009",
	"./manda/manda_003.png": "41f7",
	"./manda/manda_004.png": "9676",
	"./manda/manda_005.png": "6e03",
	"./manda/manda_006.png": "bc2d",
	"./manda/manda_007.png": "2ae8",
	"./manda/manda_008.png": "2441",
	"./manda/manda_009.png": "5c76",
	"./manda/manda_010.png": "714c",
	"./manda/manda_011.png": "8cb4",
	"./manda/manda_012.png": "d55d",
	"./manda/manda_013.png": "5e6c",
	"./manda/manda_014.png": "80a5",
	"./manda/manda_015.png": "1309",
	"./manda/manda_016.png": "2402",
	"./manda/manda_017.png": "fd0e",
	"./manda/manda_018.png": "5abb",
	"./manda/manda_019.png": "4d54",
	"./manda/manda_020.png": "c14c",
	"./manda/manda_021.png": "15db",
	"./manda/manda_022.png": "59ef",
	"./manda/manda_023.png": "8e82",
	"./manda/manda_024.png": "5a24",
	"./manda/manda_025.png": "63b6",
	"./manda/manda_026.png": "781e",
	"./manda/manda_027.png": "29f2",
	"./manda/manda_028.png": "de1b",
	"./manda/manda_029.png": "b6da",
	"./manda/manda_030.png": "d17a",
	"./manda/manda_031.png": "a665",
	"./manda/manda_032.png": "5d01",
	"./manda/manda_033.png": "45c4",
	"./manda/manda_034.png": "8b36",
	"./manda/manda_035.png": "a9e1",
	"./manda/manda_036.png": "b118",
	"./manda/manda_037.png": "2d35",
	"./manda/manda_038.png": "c14d",
	"./manda/manda_039.png": "a96c",
	"./manda/manda_040.png": "b72f",
	"./manda/manda_041.png": "c413",
	"./music/music_001.png": "3eb4",
	"./music/music_002.png": "23bc",
	"./music/music_003.png": "6a8e",
	"./music/music_004.png": "5996",
	"./music/music_005.png": "faba",
	"./music/music_006.png": "8061",
	"./music/music_007.png": "fdff",
	"./music/music_008.png": "59b4",
	"./music/music_009.png": "fce8",
	"./music/music_010.png": "b5f7",
	"./music/music_011.png": "07e1",
	"./music/music_012.png": "f0be",
	"./music/music_013.png": "a64c",
	"./music/music_014.png": "05cd",
	"./music/music_015.png": "00d5",
	"./music/music_016.png": "29af",
	"./music/music_017.png": "240a",
	"./music/music_018.png": "9fd5",
	"./music/music_019.png": "687c",
	"./music/music_020.png": "5c72",
	"./music/music_021.png": "fd0e1",
	"./music/music_022.png": "cbb6",
	"./music/music_023.png": "a66a",
	"./music/music_024.png": "47d6",
	"./music/music_025.png": "d7f1",
	"./music/music_026.png": "d58e",
	"./music/music_027.png": "7f3a",
	"./other_bell.png": "8314",
	"./other_book.png": "2f37",
	"./other_books.png": "865f",
	"./other_clock.png": "75eb",
	"./other_doll.png": "6105",
	"./other_earth.png": "0fd32",
	"./other_goal.png": "6f99",
	"./other_hourglass.png": "31f1",
	"./other_light.png": "93cf",
	"./other_teddy.png": "f66d",
	"./people/img_student1.png": "5323",
	"./people/img_student2.png": "fabc",
	"./people/img_student3.png": "4e82e",
	"./people/img_student4.png": "eb05",
	"./people/img_student5.png": "d62d",
	"./people/img_student6.png": "2913",
	"./people/img_teacher1.png": "29d9",
	"./people/img_teacher2.png": "0251",
	"./people/img_teacher3.png": "0370",
	"./people/img_teacher4.png": "8ff6",
	"./people/img_teacher5.png": "c43d",
	"./sports/sport_americanfootball.png": "9635",
	"./sports/sport_archery.png": "617c",
	"./sports/sport_badminton.png": "7847",
	"./sports/sport_baseball.png": "7bab",
	"./sports/sport_basketball.png": "0e67",
	"./sports/sport_soccer.png": "ac3c",
	"./sports/sport_tabletennis.png": "4483",
	"./sports/sport_tennis.png": "e083",
	"./sports/sport_volleyball.png": "a315",
	"./symbol/symbol_arrow1black.png": "d178",
	"./symbol/symbol_arrow1blue.png": "3304",
	"./symbol/symbol_arrow1green.png": "99ae",
	"./symbol/symbol_arrow1red.png": "d4d5",
	"./symbol/symbol_arrow1yellow.png": "895a",
	"./symbol/symbol_arrow2black.png": "516e",
	"./symbol/symbol_arrow2blue.png": "d7b0",
	"./symbol/symbol_arrow2green.png": "36ed",
	"./symbol/symbol_arrow2red.png": "6916b",
	"./symbol/symbol_arrow2yellow.png": "2403",
	"./symbol/symbol_correct.png": "a332",
	"./symbol/symbol_deleteblack.png": "8bd8",
	"./symbol/symbol_deleteblue.png": "80e0",
	"./symbol/symbol_deletegreen.png": "4e8a",
	"./symbol/symbol_deletered.png": "c229",
	"./symbol/symbol_deleteyellow.png": "bf2b",
	"./symbol/symbol_good.png": "b254",
	"./symbol/symbol_hashblack.png": "a1e8",
	"./symbol/symbol_hashblue.png": "f23d",
	"./symbol/symbol_hashgreen.png": "1f9e",
	"./symbol/symbol_hashred.png": "9d81",
	"./symbol/symbol_hashyellow.png": "47a3",
	"./symbol/symbol_heart.png": "3bad",
	"./symbol/symbol_marine.png": "9f0b",
	"./symbol/symbol_questionblack.png": "71d0",
	"./symbol/symbol_questionblue.png": "2d0e",
	"./symbol/symbol_questiongreen.png": "ee29",
	"./symbol/symbol_questionred.png": "60a0",
	"./symbol/symbol_questionyellow.png": "348a",
	"./symbol/symbol_starblack.png": "a13e",
	"./symbol/symbol_starblue.png": "9ea8",
	"./symbol/symbol_stargreen.png": "e41b",
	"./symbol/symbol_starred.png": "9808",
	"./symbol/symbol_staryellow.png": "2797",
	"./traffic_ballon.png": "7c4d2",
	"./traffic_car.png": "bfc8",
	"./traffic_scooter.png": "36ee",
	"./traffic_truck.png": "eae0a",
	"./veg_bellpepper.png": "ab16",
	"./veg_carrot.png": "1d8d",
	"./veg_mushroom.png": "92cf",
	"./weather/weather_.png": "b488",
	"./weather/weather_cloud.png": "b5ca",
	"./weather/weather_moon.png": "a740",
	"./weather/weather_rainbow.png": "8841",
	"./weather/weather_snow.png": "8e9a",
	"./weather/weather_star.png": "c184",
	"./weather/weather_sun.png": "ba4b6",
	"./weather/weather_thunder.png": "9fcc",
	"./weather/weather_tornado.png": "4d6f",
	"./weather/weather_umberlla.png": "3639",
	"./weather/weather_windy.png": "6cb3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e72";